import { useState } from "react";
import { Constants, DISCOUNTMODE } from "./Content";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { DiscountToolTip, UserRole } from "../QuoteRequest/Content"
import { Box, Button, Tooltip, Typography, TextField } from "@mui/material";
import { Severity } from "../utilities/Notification/NotificationContent";
import { useDispatch } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Grid from '@mui/material/Grid';


const BundleActions = ({ bundleId, handlePreviewDiscount, handleApproveBundle, handleSubmitBundle, rateSum, bundleArrayIndex, showNotification, loggedUser, approvalInProgress }) => {
    const dispatch = useDispatch();
    const [discountMode, setDiscountMode] = useState(DISCOUNTMODE.PERCENT);
    const [discountValue, setDiscountValue] = useState("");
    const [discountError, setDiscountError] = useState(false);
    const [discountErrorMessage, setDiscountErrorMessage] = useState("");
    const [rateTotal] = useState(rateSum);
    const [bundleIndex] = useState(bundleArrayIndex);
    const [currentBundleId] = useState(bundleId);

    const onSwitchDiscountMode = () => {
        const currentDiscountMode = discountMode;
        if (currentDiscountMode === DISCOUNTMODE.PERCENT) {
            setDiscountMode(DISCOUNTMODE.VALUE);
        } else {
            setDiscountMode(DISCOUNTMODE.PERCENT);
        }
    };

    const onPreviewDiscountClick = () => {
        if (!discountError) {
            handlePreviewDiscount(discountMode, discountValue, currentBundleId, rateTotal, bundleIndex);
        } else if (discountValue === "" || discountValue === null || discountValue === undefined) {
            showNotification(Severity.ERROR, Constants.MESSAGE_DISCOUNTEMPTY);
        }
    }

    const onDiscountChange = (e) => {
        const value = e.target.value;
        validateAndSetDiscount(value);
    }

    const validateAndSetDiscount = (value) => {
        let discountValidationError = Constants.VALIDATIONERROR_DISCOUNTINVALIDINPUT;
        let isDiscountError = Constants.VALIDATIONERROR_DISCOUNTINVALIDINPUT;
        isDiscountError = true;

        if (value === "" || value === '-') {
            discountValidationError = "";
            isDiscountError = false;
            setDiscountValue(value?.trim());
        } else if (!isNaN(value)) {

            if (discountMode === DISCOUNTMODE.PERCENT && value < -100) {
                discountValidationError = Constants.VALIDATIONERROR_DISCOUNTLESSTHANHUNDRED;
                isDiscountError = true;
                setDiscountValue("");
            }
            else {
                discountValidationError = "";
                isDiscountError = false;
                setDiscountValue(value?.trim());
            }
        }
        setDiscountErrorMessage(discountValidationError);
        setDiscountError(isDiscountError);
        return { isError: isDiscountError, errorMessage: discountValidationError };
    }

    const onApproveClick = (event, bundleId) => {
        const error = validateAndSetDiscount(discountValue);
        if (!error.isError && error.errorMessage === "") {
            handleApproveBundle(bundleId, discountValue === "" ? 0 : discountValue, discountMode, rateTotal, bundleIndex);
        }
    }

    const onSubmitClick = (event, bundleId) => {        
        const saveBundleObj = {
            bundleId: bundleId,
            userId: loggedUser?.user?.id
        };
        handleSubmitBundle(saveBundleObj, bundleIndex);        
    }

    const isSubmit = () => {
        return (loggedUser?.userRole[0]?.id === UserRole.SAMTEAM || 
            loggedUser?.userRole[0]?.id === UserRole.PRICINGTEAM || 
            loggedUser?.userRole[0]?.id === UserRole.PRICINGMANAGER || 
            loggedUser?.userRole[0]?.id === UserRole.PRICINGVP || 
            loggedUser?.userRole[0]?.id === UserRole.SAMLEADERSHIPTEAM);
    }

    // const isApprove = () => {
    //     return (loggedUser?.userRole[0]?.id === UserRole.SAMLEADERSHIPTEAM);
    // }

    return (<>        
        <Box className="bundleActionContainer">
            <Grid container spacing={2}>
                <Grid item>
                    <div className="discountTitleAndDescription">
                        <Typography
                            sx={{ width: `${Math.max(180, Constants.ADDDISCOUNT.length * 10)}px` }}
                            style={{ textAlign: "left" }}>
                            <strong>{Constants.ADDDISCOUNT}
                                <Tooltip title={<span className="tooltip" >{DiscountToolTip}</span>}>
                                    <InfoOutlinedIcon className="infoIcon" />
                                </Tooltip>
                            </strong>
                        </Typography>
                    </div>
                </Grid>
                <Grid item>
                    <div>
                        <TextField
                            className="txtDiscount"
                            onChange={onDiscountChange}
                            placeholder={discountMode === DISCOUNTMODE.PERCENT ? Constants.PLACEHOLDERTEXTDISCOUNTPERCENT : Constants.PLACEHOLDERTEXTDISCOUNTAMOUNT}
                            style={{
                                width: `${Math.max(180, discountValue.length * 10)}px`,
                            }}
                        ></TextField>
                        <Box>
                            {discountError && (
                                <span className="error">
                                    {discountErrorMessage}
                                </span>
                            )}
                        </Box>
                    </div>
                </Grid>
                <Grid item>
                    <Button
                        sx={{
                            fontFamily: '"Noto Sans", sans-serif',
                            whiteSpace: "nowrap",

                            Width: "12%",
                        }}
                        variant="outlined"
                        className="btnSwitchToPercentOrValue"
                        onClick={onSwitchDiscountMode}
                        endIcon={
                            <Tooltip title={Constants.TOOLTIP_PROMPTDUPLICATEBUNDLE}>
                                <InfoOutlinedIcon className="infoIcon" />
                            </Tooltip>
                        }
                    >
                        <strong>{discountMode === DISCOUNTMODE.PERCENT ? Constants.BUTTONDISCOUNTNAMEVALUE : Constants.BUTTONDISCOUNTNAMEPERCENT}</strong>
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        sx={{
                            fontFamily: '"Noto Sans", sans-serif',
                            whiteSpace: "nowrap",

                            width: "15%",
                        }}
                        variant="text"
                        className="btnPreviewDiscount"
                        onClick={onPreviewDiscountClick}
                        startIcon={<VisibilityOutlinedIcon />}
                    >
                        <span style={{ color: "#717171" }}>
                            <strong>
                                <u>{Constants.BUTTONDISCOUNTPREVIEW}</u>
                            </strong>
                        </span>
                    </Button>
                </Grid>
                <Grid item>
                    <div className="btnApproveContainer">
                        {isSubmit() &&
                            <><Button
                                sx={{ fontFamily: '"Noto Sans", sans-serif', }}
                                variant="contained"
                                className={(discountValue === "" || discountValue === null || discountError) ? "btnSubmitActive" : "btnSubmitInActive"}
                                onClick={(e) => onSubmitClick(e, bundleId)}
                                disabled={!(discountValue === "" || discountValue === null) || discountError || approvalInProgress}
                            >
                                <strong>{Constants.BUTTONSUBMITBUNDLE}</strong>
                            </Button>                                
                            </>
                        }

                        {/* {isApprove() &&
                            (<><Button
                                sx={{ fontFamily: '"Noto Sans", sans-serif', }}
                                variant="contained"
                                className="btnApproveBundleActive"
                                onClick={(e) => onApproveClick(e, bundleId)}
                                disabled={approvalInProgress}
                            >
                                <strong>{approvalInProgress ? Constants.BUTTONAPPROVEINPROGRESSBUNDLE : Constants.BUTTONAPPROVEBUNDLE}</strong>
                            </Button>                                
                            </>

                            )
                        } */}
                        {approvalInProgress && <CircularProgress size="30px" />}
                    </div>
                </Grid>
                <Grid item sx={12}>
                    <div className="bundleInfoContainer">
                        <InfoOutlinedIcon className="infoIcon" />
                        <Typography className="infotext">
                            {Constants?.BUNDLESUBMITINFOTEXTSTART}
                            {isSubmit() && (<>
                                <strong>{Constants?.BUTTONSUBMITBUNDLE}</strong>
                                {Constants?.BUNDLESUBMITINFOTEXTEND}
                                </>                                
                            )}

                            {/* {isApprove() && (<>
                                <strong>{Constants?.BUTTONAPPROVEBUNDLE}</strong>
                                {Constants?.BUNDLEAPPROVETINFOTEXTEND}
                                </>                                
                            )}                                                         */}
                        </Typography>
                    </div>
                </Grid>
            </Grid>                        
        </Box>        
    </>);
};

export default BundleActions;


